import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";

const Layout = () => {
	return (
		<div className="Layout">
			<Navbar />
			<main className="Content">
				<Outlet />
			</main>
		</div>
		);
}

export default Layout;